var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16V30.25",
    stroke: "#AD916F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.284 26.1175C33.8283 25.2756 35.0482 23.9434 35.7513 22.3312C36.4543 20.7189 36.6005 18.9185 36.1666 17.2139C35.7328 15.5094 34.7437 13.9979 33.3554 12.918C31.9671 11.838 30.2587 11.2512 28.4998 11.25H26.5048C26.0256 9.39631 25.1323 7.67538 23.8922 6.21659C22.6521 4.7578 21.0975 3.59911 19.3451 2.82764C17.5928 2.05618 15.6884 1.692 13.775 1.7625C11.8616 1.83299 9.98917 2.33632 8.29834 3.23465C6.60752 4.13298 5.14234 5.40293 4.01297 6.94902C2.88359 8.49511 2.11941 10.2771 1.77787 12.1611C1.43633 14.045 1.52631 15.9819 2.04107 17.826C2.55582 19.6702 3.48195 21.3736 4.74982 22.8083",
    stroke: "#AD916F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3332 22.3333L18.9998 16L12.6665 22.3333",
    stroke: "#AD916F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.73b16ba45fd437aa5945bf00ca68e102.svg";
export { ForwardRef as ReactComponent };